<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.home-hero {
    position: relative;
    z-index: auto;
    margin-bottom: 16px;

    @media screen and (min-width: $screen-md) {
        margin-bottom: 56px;
    }

    @media screen and (min-width: $screen-xl) {
        margin-bottom: 96px;
    }

    .hero {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        padding: 80px 0 120px 0;
        position: relative;

        @media screen and (min-width: $screen-lg) {
            padding: 100px 0 180px 0;
        }

        @media screen and (min-width: $screen-xl) {
            padding: 158px 0 158px 0;
        }

        &.large {
            padding: 80px 0 120px 0;

            @media screen and (min-width: $screen-lg) {
                padding: 100px 0 120px 0;
            }

            @media screen and (min-width: $screen-xl) {
                padding: 256px 0 256px 0;
            }
        }

        &:before {
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            content: "";
            background-color: rgba(43, 74, 132, 0.7);
        }

        .content {
            position: relative;
            z-index: 2;
        }

        .subtitle {
            font-weight: $font-weight-bold;
            letter-spacing: 0.29px;
            text-transform: uppercase;
        }
    }

    &:after {
        content: "";
        background-image: url("/svg/shapes/header-1.svg");
        height: 80px;
        width: 100%;
        position: absolute;
        z-index: 2;
        right: 0;
        bottom: 0;

        @media screen and (min-width: $screen-sm) {
            background-size: cover;
            background-repeat: no-repeat;
        }
    }

    .hero-button {
        background-color: $secondary;
        height: 137px;
        width: 531px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 4;
        cursor: pointer;
        justify-content: center;
        flex-direction: column;

        span {
            position: relative;
            color: $white;
            font-family: $headings-font-family;
            font-size: 20px;
            letter-spacing: 1.17px;
            text-transform: uppercase;
            position: absolute;
            left: 48px;
            top: 50%;
            transform: translateY(-50%);

            &:after {
                content: url("/svg/icons/icon-arrow-down-white.svg");
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: -48px;
                transition: top 0.2s;
            }
        }

        &:hover {
            span {
                &:after {
                    top: calc(50% + 8px);
                }
            }
        }
    }
}
</style>

<template>
    <div class="home-hero">
        <div class="hero" :class="{'large': large}" :style="`background-image: url('${image}')`">
            <div class="container content">
                <div class="row">
                    <div class="col-12 col-xl-8">
                        <span v-if="subtitle" class="subtitle small text-white d-lg-inline-block mb-lg-16">{{ subtitle }}</span>
                        <h1 class="text-white word-break">{{ title }}</h1>
                        <div v-if="wysiwig" class="text-white pt-16" v-html="wysiwig"></div>
                        <a v-if="ctaText" href="#" @click="scroll" class="btn btn-secondary btn-special btn-lg mt-32"><span>{{ ctaText }}</span></a>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="largeCtaText" class="hero-button d-none d-xl-block" @click="scroll">
            <span>{{ largeCtaText }}</span>
        </div>
    </div>
</template>

<script>
var scrollIntoView = require('scroll-into-view');

export default {
    props: {
        image: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: false,
        },
        ctaText: {
            type: String,
            required: false,
        },
        largeCtaText: {
            type: String,
            required: false,
        },
        link: {
            type: String,
            required: false,
        },
        anchor: {
            type: String,
            require: false,
        },
        large: {
            type: Boolean,
            require: false,
            default: false
        },
        wysiwig: {
            type: String,
            require: false,
        },
    },

    methods: {
        scroll(e) {
            e.preventDefault();
            var target = document.getElementById(this.anchor);
            scrollIntoView(target);
        },
    }
}
</script>
